import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Provider as ReakitProvider } from 'reakit/Provider';
import { AriaLiveProvider } from '@ally/use-aria-live';
import { muiBankTheme } from '../tools/theme';
import { SnackbarProvider } from '../Snackbar';
const MetronomeProvider = ({ theme = muiBankTheme, children, }) => (React.createElement(ThemeProvider, { theme: theme },
    React.createElement(ReakitProvider, null,
        React.createElement(AriaLiveProvider, null,
            React.createElement(SnackbarProvider, null, children)))));
export { MetronomeProvider };
//# sourceMappingURL=MetronomeProvider.js.map